module.exports = __webpack_public_path__ + "static/media/logo-food-angel.fc2eae89.png";